<template>
  <div class="poll-choice">
    <el-row :gutter="8">
      <el-col :span="8">
        <el-form label-position="left" label-width="20px">
          <el-form-item :label="`${idx + 1}.`">
            <el-input v-model="choice.choice" label="Choice" placeholder="Choice" debounce="500" :disabled="disabled"/>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="15">
        <el-input v-model="newTag" @keydown.comma.enter.tab.native.prevent="addTag" placeholder="Matches" :disabled="disabled">
          <template slot="suffix">
            <div class="poll-tags">
              <el-tag
                class="poll-tag"
                size="mini"
                v-for="tag in choice.matches"
                :key="tag"
                @close="handleCloseTag(tag)"
                closable
              >
                {{tag}}
              </el-tag>
            </div>
          </template>
        </el-input>
      </el-col>
      <el-col :span="1">
        <el-button
          icon="fa fa-trash"
          type="danger"
          @click="handleDeleteChoice"
          plain
          :disabled="disabled"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'PollChoiceInput',

  props: {
    choice: {
      type: Object,
      default: () => ({
        choice: '',
        matches: [],
      }),
    },

    idx: {
      type: Number,
      required: true,
    },

    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data: () => ({
    newTag: '',
  }),

  methods: {
    addTag() {
      if (this.newTag) {
        if (!this.tagExists(this.newTag)) this.choice.matches.push(this.newTag);
        this.newTag = '';
      }
    },

    handleCloseTag(tag) {
      this.choice.matches.splice(this.choice.matches.indexOf(tag), 1);
    },

    handleDeleteChoice() {
      this.$emit('onRemoveChoice', this.idx);
    },

    tagExists(tag) {
      return this.choice.matches.findIndex(x => x === tag) !== -1;
    },
  },
};
</script>

<style lang="scss">
.poll-choice {
  /*padding: 8px;*/
}

.poll-tag {
  margin: auto 1px;
  clear: both;
}

.poll-tags {
  float: inside;
}

.poll-tag-placeholder {
  float: right;
  color: #ccc;
  vertical-align: center;
}
</style>



// WEBPACK FOOTER //
// PollChoiceInput.vue?0e1199ce